import { StyleSheet, ScrollView } from "react-native";
import React, { useState } from "react";
import SendEmail from "../../../../components/SendEmail";
import ConfirmEmail from "../../../../components/ConfirmEmail";
import { ForgotPasswordScreenProps } from "../AuthStack";

const ForgotPasswordScreen = ({ navigation }: ForgotPasswordScreenProps) => {
	const [email, setEmail] = useState("");
	const [emailSended, setEmailSended] = useState(false);

	return (
		<ScrollView style={styles.root}>
			<SendEmail
				setEmail={setEmail}
				emailSended={emailSended}
				setEmailSended={setEmailSended}
			/>
			<ConfirmEmail
				email={email}
				emailSended={emailSended}
				navigation={navigation}
			/>
		</ScrollView>
	);
};

export default ForgotPasswordScreen;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
		paddingHorizontal: "5%",
		paddingTop: 16,
	},

	header: {
		fontWeight: "600",
		fontSize: 32,
	},
	input: {
		marginTop: 30,
		alignSelf: "center",
		width: "100%",
	},
	btn: {
		marginTop: 10,
		borderRadius: 25,
		width: "100%",
		height: 50,

		alignSelf: "center",
	},
	btnText: {
		color: "#fff",
		fontSize: 15,
		lineHeight: 30,
		width: "90%",
	},
	text: {
		letterSpacing: 0.25,
		color: "#999999",
		lineHeight: 20,
		fontWeight: "400",
		fontSize: 15,
	},
	didntRecieveCode: {
		alignSelf: "flex-end",
	},
});
